/**
 * Announcement sidebar badge store.
 * Written by `<AnnouncementBadgeSubscriber />`; read by `announcementsMenu`.
 */

import { create } from 'zustand';

interface AnnouncementBadgesState {
  drafts: number;
  upcoming: number;
  setFromMetrics: (m: Partial<Pick<AnnouncementBadgesState, 'drafts' | 'upcoming'>>) => void;
  applyDelta: (m: Partial<Pick<AnnouncementBadgesState, 'drafts' | 'upcoming'>>) => void;
  reset: () => void;
}

const EMPTY = { drafts: 0, upcoming: 0 };
const clamp = (n: number) => (n < 0 ? 0 : n);

export const useAnnouncementBadgesStore = create<AnnouncementBadgesState>((set) => ({
  ...EMPTY,
  setFromMetrics: (m) =>
    set({
      drafts: clamp(m.drafts ?? 0),
      upcoming: clamp(m.upcoming ?? 0),
    }),
  applyDelta: (m) =>
    set((state) => ({
      drafts: clamp(state.drafts + (m.drafts ?? 0)),
      upcoming: clamp(state.upcoming + (m.upcoming ?? 0)),
    })),
  reset: () => set(EMPTY),
}));
